export default "__VITE_ASSET__CJFx41sB__"